import { ContentTypes } from "../brandVariables.types";

export const jblContent: ContentTypes = {
  generalHeadline: "CS2 Time Trial",
  generalHeadlineAlt: "Set the fastest time!",
  subHeadline: "Lorem ipsum...",
  overviewHeadline: "winners overview!",
  endscreenHeadline: "Thank you and congratulations to our winners",
};
